import React, { 
  useState, 
  useEffect 
} from 'react'
import { 
  useParams 
} from 'react-router-dom'
import { 
  useGame,
  useAwards,
  useContent
} from 'data/hooks'

import noaward from 'assets/images/hipra/no-award.svg'

const Badge = props => {

  const content = props.blocks[0].blocks[0].blocks[0].content  
  const srcregex = /\/wp-content(.*)(png|jpg|svg)/g
  const match = content.match(srcregex)

  const achieved = props.mode == 'scale' ?
    parseFloat(props.stepvalue) <= parseFloat(props.value)
    :
    false /* TO DO OTHER MODES */

  const image = achieved ?
    match.length ?
      match[0]
      :
      noaward
    :
    noaward

  return <div 
    className={`
      badge
      ${ achieved ? 'achieved' : '' }
    `}
  >
    <div className="image">
      <img src={ image } />
    </div>
    <div className="legend">
      {
        <div className="badgetitle">
          { props.title }
        </div>
      }
    </div>
  </div>
}

export const Badges = props => {

  if(!props.value) { return <></> }

  const [ badgeblocks, setBadgeblocks ] = useState([])

  if(!props.contentid) { return <></> }

  const { blocks } = useContent(props.contentid)

  if(!blocks) { return <></> }

  return <div className="badges">      
    <div className="title">
      { props.title }
    </div>
    <div className="list"> 
      {
        blocks[0].blocks
        .map(badgeblock => <Badge 
          { ...props }
          { ...badgeblock } 
        />)
      }
    </div>
  </div>
}